module.exports = __webpack_public_path__ + "static/media/team-lulung.bec1bfb9.jpg";